export default function CallFab() {
  const phoneHref = "tel:+40761686603";
  return (
    <a
      href={phoneHref}
      aria-label="Sună Curățătoria Deniadi — 0761 686 603"
      className="fixed right-4 bottom-6 z-50 md:right-6 md:bottom-8 group"
      style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 1.5rem)" }}
    >
      {/* Centered wrapper exactly the size of the button */}
      <span className="relative block h-14 w-14">
        {/* Pulse layers (centered) */}
        <span aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-full bg-sky-500/30 animate-ping" />
        <span aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-full bg-sky-500/20" />
        {/* Button */}
        <span className="relative grid h-14 w-14 place-items-center rounded-full bg-sky-600 text-white shadow-lg ring-1 ring-black/10 transition-transform group-hover:scale-105">
          <PhoneIcon className="h-6 w-6" />
        </span>
      </span>
    </a>
  );
}

function PhoneIcon({ className = "h-6 w-6" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M21 16.5v2a2.5 2.5 0 0 1-2.7 2.5 16.8 16.8 0 0 1-7.3-3.1 16.6 16.6 0 0 1-5.9-5.9A16.8 16.8 0 0 1 2 4.7 2.5 2.5 0 0 1 4.5 2h2A1.5 1.5 0 0 1 8 3.2c.2 1 .6 2 .9 2.8.3.8.1 1.6-.4 2.1L7 9.7a13.8 13.8 0 0 0 7.3 7.3l1.6-1.5c.5-.5 1.3-.7 2.1-.4.9.3 1.8.7 2.8.9A1.5 1.5 0 0 1 21 16.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
